
import { Link } from 'react-router-dom';

const Logo = () => {
  return (
    <Link to="/" className="flex items-center">
      <img 
        src="/lovable-uploads/1bf3775e-431a-4813-a332-79f702e0cf9f.png" 
        alt="AutoCare Logo" 
        className="h-16 w-auto" // Increased from h-12 to h-16
      />
    </Link>
  );
};

export default Logo;
